// extracted by mini-css-extract-plugin
module.exports = {"deleteDialogWrapperDesk":"user-actions_deleteDialogWrapperDesk__exbP6","dialogButton":"user-actions_dialogButton__AxFaf"};